import { HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TranslationService } from '../transloco/services/translation.service';
import { LoadingService } from './loading.service';
import { NotificationsService } from './notifications-service/notifications.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {
    private notificationsService = inject(NotificationsService);
    private loadingService = inject(LoadingService);

    private requestCount = 0;
    private translationService = inject(TranslationService);

    // eslint-disable-next-line  @typescript-eslint/no-explicit-any
    public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.requestCount++;
        this.loadingService.isLoading.next(true);

        const accept = request.headers.get('Accept');
        if (accept === 'application/zip') {
            request = request.clone({
                responseType: 'blob',
            });
        }

        return next.handle(request).pipe(
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            map((event: HttpEvent<any>) => {
                if (event.type !== HttpEventType.Response) {
                    return;
                }

                this.removeRequest();

                if (event instanceof HttpErrorResponse) {
                    if (event.status === 403) {
                        this.notificationsService.error(this.translationService.translate('defaults.notifications.unauthorizedToAccessResource'));
                    }
                }

                return event;
            }),
            catchError((err) => {
                this.removeRequest();

                if (err.status === 429) {
                    this.notificationsService.error(this.translationService.translate('notifications.tooManyRequestsMessage'));
                }

                return throwError(() => err);
            })
        );
    }

    private removeRequest() {
        this.requestCount--;

        if (this.requestCount < 0) {
            this.requestCount = 0;
        }

        this.loadingService.isLoading.next(this.requestCount > 0);
    }
}
